document.addEventListener('DOMContentLoaded', function() {
    const checkboxes = document.querySelectorAll('input[name="related_companies[]"]');
    const relatedCompanies = document.querySelectorAll('.related__companies');
    const sectionSelectors = document.querySelectorAll('.select-section');
    const threadBtn = document.querySelector('.thread-exchange-button');
    const printBtn = document.querySelector('.print-button');

    relatedCompanies.forEach(el => {
      el.style.display = 'none';
    });
  
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
           const checkedCount = document.querySelectorAll('input[name="related_companies[]"]:checked').length;
           const selectedValues = Array.from(document.querySelectorAll('input[name="related_companies[]"]:checked')).map(checkbox => checkbox.value);
           console.log(selectedValues);
           if(checkedCount >= 3){
              checkboxes.forEach(el => {
                    if (!el.checked) {
                        el.disabled = true;
                    }
                });
           }else{
                checkboxes.forEach(el => {
                    el.disabled = false;
                });
           }
          
            relatedCompanies.forEach(company => {
                if (selectedValues.includes(company.getAttribute('data-related-company'))) {
                    company.style.display = '';
                    company.classList.add('dynamic-element');
                } else {
                    company.style.display = 'none';
                    company.classList.remove('dynamic-element');
                }
            });
          
        });
    });

   sectionSelectors.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
         const status = event.target.checked;
         const targetElements = document.querySelectorAll(`.${event.target.value}`);
        /* if (event.target.value == 'show-larger-image'){
            if(status){
              document.querySelector('.design-images').classList.add('large-image');
            }else{
              document.querySelector('.design-images').classList.remove('large-image');
            }
         }*/
         targetElements.forEach(el=>{
            if(status){
              el.style.display = "block";
            }else{
              el.style.display = "none";
            }   
         });
      });
   });

   threadBtn.addEventListener('click', () => {
     const targetElement = document.querySelector('.thread-exchange');
     targetElement.scrollIntoView({ behavior: "smooth" });
   });

  printBtn.addEventListener('click', () => {
     console.log('print');
     const printContents = document.querySelector('#panel-1').innerHTML;
     const printWindow = window.open('', '', 'height=600,width=800');
  
     printWindow.document.write('<html><head><title>Print</title></head><body>');
     printWindow.document.write(printContents);
     printWindow.document.write('</body></html>');
  
     printWindow.document.close();
  
     printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
     };
  });
  
});